"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _cart = require("../apis/shopify/cart");
var _constants = require("../constants/constants");
var CartWatcher = /*#__PURE__*/function () {
  function CartWatcher() {
    (0, _classCallCheck2["default"])(this, CartWatcher);
    this.cartObserver = null;
  }
  return (0, _createClass2["default"])(CartWatcher, [{
    key: "init",
    value: function () {
      var _init = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return this.emitCartChanges();
            case 3:
              this.observeCartChanges();
              _context.next = 9;
              break;
            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](0);
              console.error("Error initializing CartWatcher:", _context.t0);
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 6]]);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "emitCartChanges",
    value: function () {
      var _emitCartChanges = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var cart, event;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return (0, _cart.fetchCart)();
            case 2:
              cart = _context2.sent;
              event = new CustomEvent(_constants.EVENT_TYPE.CUSTOM.CART_UPDATED, {
                detail: cart
              });
              window.dispatchEvent(event);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function emitCartChanges() {
        return _emitCartChanges.apply(this, arguments);
      }
      return emitCartChanges;
    }()
  }, {
    key: "observeCartChanges",
    value: function observeCartChanges() {
      var _this = this;
      if (this.cartObserver) return;
      this.cartObserver = new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (entry) {
          var isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
          var isCartChangeRequest = /\/cart\//.test(entry.name);
          if (isValidRequestType && isCartChangeRequest) {
            _this.emitCartChanges();
          }
        });
      });
      this.cartObserver.observe({
        entryTypes: ["resource"]
      });
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      if (this.cartObserver) {
        this.cartObserver.disconnect();
        this.cartObserver = null;
      }
    }
  }]);
}();
var cartWatcher = new CartWatcher();
var _default = exports["default"] = cartWatcher;
//# sourceMappingURL=cart-watcher.js.map
